
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';

const { productTag } = api;

@Component({
  components: { },
})
export default class swapOutProductTag extends Vue {
  private data = { data: [] };

  private headers = [
    { text: 'ID', value: 'tagId' },
    { text: '名稱', value: 'tagName' },
    { text: '顯示於前台', value: 'isVisible' },
    { text: '顏色', value: 'tagColor' },
    { text: '適用商品', value: 'tageProducts' },
    { text: '修改', value: 'edit', sortable: false },
    { text: '刪除', value: 'delete', sortable: false },
  ];

  private get collection() {
    return [...(this.data.data || [])];
  }

  private async handleOpenDelete(tagId: any) {
    await Swal.fire(
      {
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await productTag.delete(tagId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: message });
        }
      }
    });
  }

  private async requestData() {
    const data = await productTag.list();
    this.data = data;
  }

  private async created() {
    await this.requestData();
  }
}
